import { TValidator } from "../../../../wizard/types";
import { WIZARD_ERROR_MESSAGE } from "../../../../wizard/constants";
import { mutateErrors } from "../../../../../utils";
import { parseToCheckDuplicationModel } from "../../../helpers/parseToCheckDuplicationModel";

type CommonObject = { [key: string]: any };

const validator: TValidator = async ({
  values,
  activeStepName,
  backendValidator,
}) => {
  const errors: CommonObject = {};
  const notifyMessages: string[] = [];

  const activeStepValues = values[activeStepName] ?? {};

  // Language -----------------------------------------------
  if (!activeStepValues.language?.id) {
    errors.language = "Language is required";
  }

  // Categories -----------------------------------------------
  if (!activeStepValues.category) {
    errors.category = "Category is required";
  } else if (activeStepValues.category.trim().length > 100) {
    errors.category = "Category must have maximum 100 characters";
  }

  // Course Type -----------------------------------------------
  if (!activeStepValues.courseType) {
    errors.courseType = "Select an option";
  }

  // Age Range -----------------------------------------------
  const minAge = activeStepValues.minAge?.trim();
  const maxAge = activeStepValues.maxAge?.trim();

  if (!minAge) {
    errors.minAge = "Minimum age is required";
  } else if (!Number.isInteger(+minAge)) {
    errors.minAge = "Minimum age is not valid";
  } else if (minAge < 7) {
    errors.minAge = "Minimum age must be greater or equal to 7";
  } else if (minAge > 100) {
    errors.minAge = "Minimum age must be less or equal to 100";
  }

  if (maxAge) {
    if (!Number.isInteger(+maxAge)) {
      errors.maxAge = "Maximum age is not valid";
    } else if (maxAge < 7) {
      errors.maxAge = "Maximum age must be greater or equal to 7";
    } else if (maxAge > 100) {
      errors.maxAge = "Maximum age must be less or equal to 100";
    }
  }

  if (minAge && maxAge && +minAge > +maxAge) {
    //TODO: show error text only on last modified input
    errors.minAge = "Minimum age must be less than maximum age";
    errors.maxAge = "Maximum age must be greater than minimum age";
  }

  // Branches -----------------------------------------------------
  if (!activeStepValues.branches || activeStepValues.branches.length === 0) {
    const message = "Please select at least one branch";

    errors.branches = message;
    notifyMessages.push(message);
  }

  if (Object.keys(errors).length > 0) {
    throw {
      [WIZARD_ERROR_MESSAGE]: notifyMessages.join("\n\n"),
      [activeStepName]: errors,
    };
  }

  try {
    const parsedData = parseToCheckDuplicationModel({
      id: values.id,
      schoolId: values.schoolId,
      ...activeStepValues,
    });
    await backendValidator!(parsedData);
  } catch (error) {
    const { message } = mutateErrors(error);

    throw {
      [WIZARD_ERROR_MESSAGE]: message,
    };
  }
};

export default validator;
